import gql from 'graphql-tag';

export const SimpleLabelFragment = gql`
	fragment SimpleLabelFragment on LabelType {
		pk
		name
		type
		color
	}
`;

export const LabelFragment = gql`
	fragment LabelFragment on LabelType {
		id
		...SimpleLabelFragment
		parent {
			pk
			name
		}
		children {
			pk
			name
			type
			color
		}
		organizationPsId
		created
		createdBy {
			firstName
			lastName
			name
			displayName
		}
		updated
		updatedBy {
			firstName
			lastName
			name
			displayName
		}
	}
	${SimpleLabelFragment}
`;

export const LabelsQuery = gql`
	query LabelsQuery {
		labels {
			...LabelFragment
		}
	}
	${LabelFragment}
`;
